module.exports = __webpack_public_path__ + "img/20190921101617372.e35013d7.jpg";